import { render, staticRenderFns } from "./EmploymentDetails.vue?vue&type=template&id=364b379c"
import script from "./EmploymentDetails.vue?vue&type=script&lang=ts"
export * from "./EmploymentDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports